<tcc-simplePanel [size]="panalSize" [ngClass]="{ 'print-hide': !hasNoChildBladesOpen }">

    <div panel-header>Financial Planning Maintenance {{(userChangeSubject | async)?.features}}</div>
    <div panel-body>

      <ul class="nav nav-tabs mt-4 mb-3" id="myTab" role="tablist">
        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
          <a class="nav-link nonLink"
            [class.active]="activeTab === i"
            (click)="setActiveTab(i)" 
            id="tab{{i}}"
            role="tab"
            aria-controls="feed"
            [attr.aria-selected]="activeTab === i ? true : false">
            {{tab}}
          </a>
        </li>
      </ul>

      <div class="tab-content" id="myTabContent">
        <ng-container *ngFor="let tab of tabs; let i = index">
          <div class="tab-pane fade" 
            [class.show]="activeTab === i"
            [class.active]="activeTab === i"
            id="content{{i}}" 
            role="tabpanel" 
            [attr.aria-labelledby]="'tab' + i"
            *ngIf="activeTab === i">             

            
            <ng-container *ngIf="tab === 'Installer'">
              <app-financial-planning-installer></app-financial-planning-installer>               
            </ng-container>
            
            <ng-container *ngIf="tab === 'Installer Tracking'">
                <app-financial-planning-installer-tracking></app-financial-planning-installer-tracking>
            </ng-container>           
            
            <ng-container *ngIf="tab === 'Application Views'">
              <app-application-views></app-application-views>              
            </ng-container>  

            <ng-container *ngIf="tab === 'Ledger View Info'">
              <app-ledger-views></app-ledger-views>              
            </ng-container>             
            
            <ng-container *ngIf="tab === 'Position Types'">
              <app-position-types></app-position-types>              
            </ng-container>  

             <ng-container *ngIf="tab === 'System Config'">
              <app-system-config></app-system-config>               
            </ng-container>  

            <ng-container *ngIf="tab === 'Organizations'">
              <app-organizations></app-organizations>      
            </ng-container> 

            <ng-container *ngIf="tab === 'FP Lists'">                                            
              <div *ngIf="fpGroupRows">                               
                <app-financial-planning-lists [fpGroupRows]="fpGroupRows"
                  (refreshGroupKey)="getReportingGroupsSub()" (cloneGroupKey)="openCloneGroupKey($event)"
                  (deleteGroupKey)="deleteGroupKey($event)">
                </app-financial-planning-lists>                
              </div>
            </ng-container>  

            <ng-container *ngIf="tab === 'Org Mapping Lookup'">
              <app-org-mapping-lookup></app-org-mapping-lookup>      
            </ng-container>

            <ng-container *ngIf="tab === 'Account Split Definitions'">
              <app-account-split></app-account-split>      
            </ng-container>             

            <ng-container *ngIf="tab === 'Management Fee Account Splits'">
              <app-management-fee-account-splits></app-management-fee-account-splits>      
            </ng-container> 

          </div>
        </ng-container>
      </div>
    </div>
</tcc-simplePanel>
<!-------------------------------------------------------------------------------------------------------------------------------------------------------------Side Panel -->
<!-------------------------------------------------------------------------------------------------------------------------------------------------------------Side Panel -->
<tcc-simplePanel *ngIf="displayGroupKeyEditPanal()" [buttons]="['close']" (buttonClick)="close()"
    [ngClass]="{ 'print-hide': !hasNoChildBladesOpen }">

    <div panel-header>{{ currentGLReportingGroup?.groupKey }} - {{ currentGLReportingGroup?.name }}</div>
    <div panel-body>

        <table id="button-table">
            <col width="85%">
            <col width="15">
            <tr>
                <td style="border: none;">
                    <div *ngIf="groupKeyMemberDuplicateCounts > 0">
                        Updates {{dataSetUpdateCounts}}
                    </div>
                    <div *ngIf="groupKeyMemberDuplicateCounts > 0">
                        <span style="color: red;">
                            Duplicate {{groupKeyMemberDuplicateCounts > 0}}
                        </span>
                    </div>
                </td>
                <td style="border: none;">
                    <div *ngIf="dataSetUpdateCounts > 0 && groupKeyMemberDuplicateCounts === 0" class="action-buttons"
                        ngbTooltip="Save All Updates">
                        <a (click)="saveAllDirtyGroupMembers()">
                            <i class="fa fa-save" style="color: blue"></i>
                        </a>
                    </div>
                    <div *ngIf="dataSetUpdateCounts === 0" class="action-buttons" ngbTooltip="Add New Member">
                        <a (click)="add()">
                            <i class="fa fa-plus" style="color: green"></i>
                        </a>
                    </div>
                    <div class="action-buttons" ngbTooltip="Refresh">
                        <a (click)="refresh()">
                            <i class="fa fa-circle-notch" style="color: green"></i>
                        </a>
                    </div>
                </td>
            </tr>

        </table>

        <app-add-group-key-member *ngIf="showAddGroupKeyMembersTable" [groupKey]="currentGroupKeySelected"
            (hide)="hideAddNewGroupKeyMember()" (save)="saveAddNewGroupKeyMember($event)">
        </app-add-group-key-member>

        <hr />

        <table id="member-list-table">
            <col width="15%">
            <col width="15%">
            <col width="15%">
            <col width="35%">
            <col width="20%">
            <tbody>
                <tr *ngFor="let r of workingGroupKeyMemberList">
                    <td>{{currentGroupKeySelected}}</td>
                    <td>
                        <input type="text" size="8" [value]="r.orgCode" tabindex="-1" #CurrentInput
                            [appKeyboardDirectionalEvents] id="{{r.orgCodeInputElementId}}"
                            (input)="fieldChanged(CurrentInput)"
                            (directionalEvent)="onDirectionEvent(CurrentInput, $event)" />
                    </td>
                    <td>
                        <input type="text" size="8" [value]="r.propertyCode" tabindex="-1" #CurrentInput2
                            (input)="fieldChanged(CurrentInput2)" [appKeyboardDirectionalEvents]
                            id={{r.propertyCodeInputElementId}}
                            (directionalEvent)="onDirectionEvent(CurrentInput2, $event)" />
                    </td>
                    <td>
                        {{r.groupKey}}::{{r.orgCode}}::{{r.propertyCode}}
                    </td>
                    <td>
                        <div *ngIf="dataSetUpdateCounts === 0" class="action-buttons" ngbTooltip="Delete">
                            <a (click)="deleteGLReportingGroupMember(r.groupKey!, r.orgCode!, r.propertyCode!)">
                                <i class="fa fa-trash" style="color: slategray"></i>
                            </a>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</tcc-simplePanel>

<!-------------------------------------------------------------------------------------------------------------------------------------------------------------Side Panel -->
<!-------------------------------------------------------------------------------------------------------------------------------------------------------------Side Panel -->

<tcc-simplePanel *ngIf="showCloneGroupKey" [buttons]="['close']" (buttonClick)="closeCloneGroupKey()">

    <div panel-header>Clone</div>
    <div panel-body>
        <app-clone-group-key [fpGroupRows]="fpGroupRows" [groupToClone]="currentGroupKeyToClone"
            (clone)="cloneGroupKey($event)">
        </app-clone-group-key>
    </div>
</tcc-simplePanel>

<router-outlet></router-outlet>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>